import { Button as RacButton, Link as RacLink } from 'react-aria-components';
import styled, { css } from 'styled-components';

export const sharedLinkStyles = css`
  cursor: pointer;
  font-size: var(--font-size-text-md);
  font-weight: var(--font-weight-regular);
  color: var(--brand-900);
  text-decoration: underline;
  text-decoration-color: var(--brand-900);
  text-underline-offset: 3px;

  &[data-hovered] {
    color: var(--grey-600);
    text-decoration: underline;
    text-decoration-color: var(--grey-600);
  }
  
  &[data-disabled] {
    color: var(--grey-400);
    font-weight: var(--font-weight-medium);
    text-decoration-color: var(--grey-400);
  }

  &[data-focus-visible] {
    background: var(--brand-100);
    border-radius: 4px;
    box-shadow: var(--shadow-focus);
    text-decoration: underline;
    text-decoration-color: var(--brand-900);
    outline: 0;
  }
`;

export const Button = styled(RacButton)`
  ${sharedLinkStyles}

  background: transparent;
  border: 0;

  &[data-hovered] {
    background: var(--brand-100);
    border-radius: 4px;
    box-shadow: var(--shadow-focus);
  }

  :where([role="dialog"] nav) & {
    font-weight: var(--font-weight-medium);
    text-decoration: none;
  }
`;

export const Link = styled(RacLink)`
  ${sharedLinkStyles}

  :where(.header__utility_authentication) &,
  :where(.react-aria-MenuItem) &,
  :where([role="dialog"] nav) & {
    text-decoration: none;
  }
`;
